export default "__VITE_ASSET__7S9S1AG4__"